import React from "react";
import { useHistory, Link } from "react-router-dom";

import * as S from "./styles";

export const BannerOrofacial: React.FC = () => {
  const history = useHistory();
  return (
    <S.Container as={Link} to="/harmonizacao-orofacial">
      <S.AreaCta>
        {/* <S.GroupText>
                <p>
                  A Orthopride é a rede de clínicas de ortodontia que mais cresce no
                  Brasil! Marque já a sua avaliação e descubra o que podemos fazer por
                  você!
                </p>
              </S.GroupText> */}
        <S.GroupButtons>
          {/* <S.Button
            btStyle="secondary"
            type="button"
            onClick={() => history.push("/encontre-uma-unidade")}
          >
            Encontre uma unidade
          </S.Button> */}
          <S.Button
            btStyle="light"
            type="button"
            onClick={() => history.push("/agendar-avaliacao")}
          >
            Agendar Minha Avaliação
          </S.Button>
        </S.GroupButtons>
      </S.AreaCta>
    </S.Container>
  );
};
